import React from 'react';

const Stepper = ({ steps, currentStep }) => {
    // console.log('steps', steps, currentStep, typeof(steps), typeof(currentStep))
  return (
    <div className="flex items-center justify-center space-x-2">
      {Array.from({ length: steps }, (_, index) => {
        const isActive = (index.toString() === currentStep);
        const isCompleted = index < currentStep;
        // console.log('isActive', isActive, 'isCompleted', isCompleted,index, currentStep, (index.toString() === currentStep) )
        return (
          <div
            key={index}
           className='flex justify-center h-8 items-center'
          >
            <span
              className={`  rounded-full ${
                isActive ? 'bg-white w-8 h-1.5' : isCompleted ? 'bg-white w-2 h-1.5' : 'bg-gray-400 w-1.5 h-1.5'
              }`}
            />
          </div>
        );
      })}
    </div>
  );
};

export default Stepper;
